import { combineLatest } from "rxjs"
import { tap } from "rxjs/operators"
import { ApiService } from "./api/api.service"
import { LoadFormModelService } from "./load-form-model/load-form-model.service"
import { SetupService } from "./setup/setup.service"


export function load(loadFormModel: LoadFormModelService, setup: SetupService, api: ApiService) {
  return () => combineLatest([
    loadFormModel.load().pipe(tap(model => setup.updateState(model))),
    api.getDevice().pipe(tap(device => setup.setupDevice(device)))
  ]).pipe(
    tap(() => setup.setupQueryParams()),
    tap(([model, device]) => document.body.className = document.body.className + device.os?.name === 'Windows' ? ' Windows' : '')
  ).toPromise()
}

export const deps = [LoadFormModelService, SetupService, ApiService]